module.exports = __webpack_public_path__ + "static/media/pc.8ca0cab5.svg";